module.exports = __webpack_public_path__ + "static/img/ydyl5.e63e99b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/ydyl5.jpg
// module id = QVGM
// module chunks = 0